export default {
	"accountsReceivable": {
		"mergeBill": "merge",
		"createBill": "Create an invoice",
		"importButtom": "import billing fee",
		"billName": "bill name",
		"billNameInput": "Please enter billing name (required)",
		"billNameSelect": "Please select a billing name (required)",
		"billNo": "billing number",
		"checkPersonName": "reconciler",
		"confirmPersonName": "Confirmor",
		"confirm": "confirm bill",
		"complete": "complete reconciliation",
		"dialogBillErrorTitle": "Confirm billing error message",
		"dialogBillCreateTitle": "Create an invoice",
		"orderCount": "progress (order)",
		"billStartDt": "start date",
		"billEndDt": "end date",
		"billingCost": "Calculation fee (yuan)",
		"adjustCosts": "Adjustment fee (yuan)",
		"finalCosts": "Final cost (yuan)",
		"checkCost": "Counterpart fee (yuan)",
		"differenceCosts": "Reconciliation difference (yuan)",
		"confirmDt": "confirmation time",
		"checkDt": "Reconciliation time",
		"importDialogTitle": "import fee",
		"flagTips": "Please select multiple bills from the same shipper and unconfirmed status before they can be combined!",
		"selectDouble": "Please select at least two data!"
	},
	"billingConfirm": {
		"bill": "bill",
		"bizCost": "business expenses",
		"fixedCost": "Fixed costs",
		"totalCost": "Total cost",
		"downloadAccountbill": "Download billing",
		"recountBill": "Recalculate billing",
		"adjustAccountBill": "Adjust the account period",
		"changeBill": "switch bill",
		"systemCalculation": "System Computing",
		"userCalculation": "Manual adjustment",
		"finalCalculation": "final cost",
		"costConfirmationProgress": "Fee confirmation progress",
		"billingRequestTime": "Billing initiation time",
		"recalculation": "Recalculate",
		"addFixedCost": "Add fee",
		"billingItemsName": "Billing item",
		"billingDescription": "Fee description",
		"orderBillTabLable": "shipping order fees",
		"singleReConfirm": "anti-confirmation",
		"orderService": "Order service",
		"orderBillingCost": "approximate cost",
		"workServiceType": "operation service",
		"orderServiceType": "Adjusted Fee",
		"clear": "clear",
		"change": "Adjust",
		"exceptBill": "abnormal billing",
		"totalPay": "total amount paid",
		"billInfo": "Document information",
		"keyWords": "field",
		"xkeyWords": "Correction value",
		"wkeyWords": "job value",
		"cost": "cost",
		"carInfo": "Dispatch information",
		"serviceInfo": "Service Information",
		"changeCost": "fee adjustment",
		"beforeCost": "Price before adjustment (yuan)",
		"afeterCost": "Adjusted price (yuan)",
		"noCharge": "not calculate this fee",
		"endDtDialogTitle": "Adjust end date",
		"changeBillDialogTitle": "switch bill",
		"billNameTitle": "Modify bill name",
		"accountResetDialogTitle": "Please select a recalculation item",
		"YS_YS": "Shipping (yuan)",
		"pickUpTime": "Pickup Date",
		"endTime": "date of receipt",
		"billNameTips": "Please select a billing name",
		"changeBillObjTips": "Whether to confirm the switch bill",
		"cleanAdjustTips": "Are you sure to clear the adjustment?",
		"adjustBillEndDtTips": "Please select an end date"
	},
	"reconciliation": {
		"reConfirmFn": "Reconfirmation",
		"recheckFn": "Reconciliation",
		"importBill": "Import & Reconciliation",
		"collectData": "Reconciliation progress",
		"oppositeValue": "counterpartner value",
		"async": "Synchronize",
		"fixTypeName": "calibrate model",
		"oppositeTypeName": "counterpartner's vehicle type",
		"fixPlateNo": "Fix license plate",
		"selectTypeBool": "Whether to serve",
		"serviceItems": "service item",
		"projectIdTips": "The shipping product is wrong and cannot be synchronized!",
		"temperatureControlNoTips": "The temperature control type is wrong and cannot be synchronized!",
		"goodsTypeIdTips": "The item type is wrong and cannot be synchronized!",
		"synProvinceOriginDistrictTips": "The originating province/city/district of the other party's value is incorrect and cannot be synchronized!",
		"originatingSiteIdTips": "The originating site is wrong and cannot be synchronized!",
		"destinationProvinceTips": "The destination province/city/district of the other party is wrong and cannot be synchronized!",
		"destinationSiteIdTips": "The destination site is wrong and cannot be synchronized!",
		"ourStyle": "our format",
		"otherStyle": "counterpart format"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/accountsReceivable/accountsReceivable.js